import { atom, selector } from "recoil";
import _crypto from "crypto-js";

export const userState = atom({
  key: 'userState',
  default: selector({
    key: 'userStateSelector',
    get: () => {
      const token = sessionStorage.getItem('token');
      const authKey = _crypto.AES.decrypt(token, process.env.REACT_APP_CRYPTO_KEY);
      const auth = JSON.parse(authKey.toString(_crypto.enc.Utf8));
      return {
        userId: auth.userId,
        customer: auth.airlineCd
      }
    },
  })
})